// extracted by mini-css-extract-plugin
export default {"wrapper":"BD-z","button":"CD-z","alternate":"DD-z","disabled":"ED-z","paymentWarning":"FD-z","fadeIn":"GD-z"};